<template>
  <div v-if="activeTab === 0">
    <SingleEditObjectMainInfoCompanies :editableLabel="'Company *'" :editableInputOptions="allCompanies.data"
      :editingData="editingData" :data="!!selectedCompany.id ? selectedCompany : null" @update-company="updateDataCompany($event)"/>
  </div>
  <div v-else-if="activeTab === 1">
    <SingleEditObjectMainInfoRoles :editableLabel="'Role *'" :editableInputOptions="allRoles.data"
      :editingData="editingData" :data="!!selectedRole.id ? selectedRole.id : null" @update-roles="updateDataRole($event)" />
  </div>
  <div v-else-if="activeTab === 2">
    <div class="tableDivContainer">
      <Table :checkbox="false" :loading="loading" :headers="headers" :items="workspaces" :sortable="true"
        @onScrollBottom="onScrollBottom" @onScrollTop="onScrollTop" @sortClick="onSortClick" :emitRowClickBusEvent="false"
        @selectedRows="onCheckboxClick($event)" />
    </div>
  </div>
</template>
  
<script>
import { listsMixin } from "@/mixins/listsMixin";
import { mapActions } from "vuex";
import InputField from "@/newComponents/_Atoms/InputField.vue";
import Table from "@/newComponents/_Molecules/Table.vue";
import SingleEditObjectMainInfoCompanies from "@/newComponents/_Organisms/SingleEditObjectMainInfoCompanies.vue";
import SingleEditObjectMainInfoRoles from "@/newComponents/_Organisms/SingleEditObjectMainInfoRoles.vue";

export default {
  name: "UserSpecificInfoList",

  components: {
    InputField,
    Table,
    SingleEditObjectMainInfoCompanies,
    SingleEditObjectMainInfoRoles
  },

  mixins: [listsMixin],

  props: {
    /**
     * The specific fields values passed by the parent component
     */
    fields: {
      type: Array,
      required: true,
    },

    editingData: {
      type: Boolean,
      required: true,
    },

    updateComponent: {
      type: Number,
    },

    selectedCompany: {
      type: Object
    },

    selectedRole: {
      type: Object
    },
  },

  data() {
    return {
      allCompanies: [],
      allRoles: [],
      headers: [
        { text: "Label", value: "wp_label" },
        { text: "Plan Name", value: "wp_plan_name" },
        { text: "Phase", value: "wp_status" },
      ],
      workspaces: [],
      roleIndex: 0,
      companyIndex: 0,
      activeTab: 0
    }
  },

  mounted() {
    this.getAllCompanies();
    this.getAllRoles();
    this.getAllWorkspaces();
    this.getProjectPhases();
    this.loadProjectPhases();
  },

  methods: {

    ...mapActions(["fetchAllCompanies", "FETCH_ALL_ROLES_PERMISSIONS_LIST", "fetchAllWorkspaces"]),

    async getAllCompanies() {
      try {
        const response = await this.fetchAllCompanies({ paginate: false });
        if (response.data && response.data.length > 0) {
          this.allCompanies = {
            ...response,
            data: response.data.map(company => ({
              ...company,
              code: company.id
            }))
          };
        } else {
          this.allCompanies = response;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    getAllWorkspaces() {
      this.fetchAllWorkspaces({
        fields: "wp_label,wp_plan_name,wp_status"
      })
        .then(workspaces => {
          this.workspaces = workspaces;
          this.workspaces = this.workspaces.map(item => {
            item.wp_status = this.getProjectPhaseName(item.wp_status);
            return item;
          });
        })
        .catch(error => {
          console.error(error);
        })
        .then(() => {
          this.loading = false;
        });
    },

    updateDataRole(id) {
      const index = this.allRoles.data.findIndex(element => element.id === id);
      this.roleIndex = index;
    },

    updateDataCompany(id) {
      const index = this.allCompanies.data.findIndex(element => element.id === id);
      this.companyIndex = index;
    },

    getProjectPhases() {
      this.projectPhases = this.$store.getters.optionLists_phase;
    },

    loadProjectPhases() {
      let projectPhaseOptions = [];
      let projectPhases = this.$store.getters.optionLists_phase;
      for (const projectPhase of projectPhases) {
        projectPhaseOptions.push({
          text: projectPhase.client_label
            ? projectPhase.client_label
            : projectPhase.libelle,
          value: projectPhase.code,
        });
      }
      this.projectPhaseOptions = projectPhaseOptions;
    },

    getProjectPhaseName(id) {
      if (id && this.workspaces.length > 0) {
        // let phase = this.workspaces.find((item) => item.code === id);
        return this.getListElementLabel(id);
      } else return id;
    },


    async getAllRoles() {
      try {
        const response = await this.FETCH_ALL_ROLES_PERMISSIONS_LIST({ paginate: false });
        if (response.data.data && response.data.data.length > 0) {
          this.allRoles = {
            ...response,
            data: response.data.data.map(role => ({
              ...role,
              code: role.id
            }))
          };
        } else {
          this.allRoles = response;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    cardInfoItemStyling() {
      return {
        'width': this.editingData ? '100%' : 'auto',
        'margin': !this.editingData ? '10px 12px 10px 0' : '6px 9px 6px 0'
      }
    },
  }
}
</script>
  
<style scoped>
.text-in-between {
  margin: 0 10px;
}

.specific-field-view-container {
  text-align: left;
  padding: 12px 0 7.5px 0;
}

.specific-field-view-container span {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 11.5px;
  /* 115% */
}

.specific-field-view-container span:last-child {
  font-weight: 700;
}

.specific-field-view-container:not(:last-child) {
  border-bottom: 1px solid #DBDBE0;
}

.specific-fields-view-container {
  width: 100%;
}

.card-info {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-width: 100%;
}

.card-info-item-container {
  display: flex;
  flex-direction: row;
  gap: 13px;
}

.card-info-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1px;
}
</style>


// WEBPACK FOOTER //
// src/newComponents/Accounts/UserSpecificInfoList.vue